// // Use $ instead of jQuery without replacing global $
(function ($) {
    // On DOM ready
    $(document).ready(function () {
        var tabHeight = $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(0)").outerHeight();
        $("body .tab-content-grid .tab-grid-outer .tab-grid li:eq(0)").addClass("active");
        $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(0)").addClass("active");
        $("body .tab-content-grid .tab-grid-outer .tab-content").css({"height": tabHeight + "px"});
        var text = $("body .tab-content-grid .tab-grid-outer .tab-grid li:eq(0) a").text();
        $("body .tab-content-grid .tab-grid-outer .mobile-panel button span").text(text);
        $("body .tab-content-grid .tab-grid-outer .tab-grid li a").on("click", function (e) {
            e.preventDefault();

            var index = $(this).parent().index();
            var tabHeight = $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(" + index + ")").outerHeight();
            var text = $(this).text();

            $("body .tab-content-grid .tab-grid-outer .mobile-panel button span").text(text);
            $("body .tab-content-grid .tab-grid-outer .tab-grid li").removeClass("active");
            $(this).parent().addClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane").removeClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(" + index + ")").addClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content").css({"height": tabHeight + "px"});
        });

        $("body .tab-content-grid .tab-grid-outer .mobile-panel li a").on("click", function (e) {
            e.preventDefault();

            var text = $(this).text();
            var index = $(this).parent().index();
            var tabHeight = $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(" + index + ")").outerHeight();

            $("body .tab-content-grid .tab-grid-outer .mobile-panel button span").text(text);
            $("body .tab-content-grid .tab-grid-outer .mobile-panel ul").slideUp();
            $("body .tab-content-grid .tab-grid-outer .tab-grid li").removeClass("active");
            $(this).parent().addClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane").removeClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content .tab-pane:eq(" + index + ")").addClass("active");
            $("body .tab-content-grid .tab-grid-outer .tab-content").css({"height": tabHeight + "px"});
        });

        $("body .tab-content-grid .tab-grid-outer .mobile-panel button").on("click", function () {
            $(this).siblings('ul').slideToggle();
        });

        $(document).on("click", " .tab-content-grid .tab-grid-outer .tab-content .content-wrapper .content a.scroll", function (e) {
            var scroll = $(window).scrollTop();
            var url = window.location.pathname;
            if (url.indexOf("/portfolio") >= 0) {
                e.preventDefault();
                var id = $(this).attr("href");
                $("#portfolio-industry .sub-menu.hidden-filter li").each(function () {
                    var filter_text = $(this).text();
                    if (filter_text === id) {
                        $(this).trigger("click");
                    }
                });
                var target = $(".portfolio-filter");
                var offsetTop = target.offset().top;
                if (scroll > offsetTop) {
                    var navHeight = $('.header-menu').height();
                } else {
                    var navHeight = 0;
                }
                $('html, body').animate({
                    scrollTop: $(".portfolio-filter").offset().top - navHeight - 20
                }, 500);
            }
        });
    });
})(jQuery);